<template>
  <!-- <div class="chart-bar" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)"> -->
  <!-- <div class="title">
      <span>{{ title }}</span>
      <div>
        <ElementSelect
          :val="year"
          @val="
            (e) => {
              year = e;
            }
          "
        />
      </div>
    </div> -->
  <div class="chart-con">
    <!-- <div class="tool-box">
      <div class="tool-left"><i></i>迁入</div>
      <div class="tool-right"><i></i>迁出</div>
    </div> -->
    <div ref="bar-chart4" class="bar-chart" id="chart4" v-if="chartData">
      <vue-seamless-scroll :data="chartData" :class-option="classOption">
        <div class="line" v-for="line in chartData">
          <div class="addr">{{ line.addr }}</div>
          <div class="chart-line">
            <div class="line-box line-left" @click="openTransferModal(line.addr, 1)">
              <span>{{ line.in }}</span>
              <div class="line-bg">
                <div class="line-bar" :style="`width: ${line.inp}%`"></div>
              </div>
            </div>
            <div class="line-box line-right" @click="openTransferModal(line.addr, 2)">
              <span>{{ line.out }}</span>
              <div class="line-bg">
                <div class="line-bar" :style="`width: ${line.outp}%`"></div>
              </div>
            </div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
    <!-- <v-chart ref="bar-chart4" :id="chartId" class="bar-chart" :options="chartOption" /> -->
  </div>
  <!-- </div> -->
</template>

<script>
import TabList from '../../../components/tabList';
import ElementSelect from '../../../components/element-select';
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: 'ChartBar',
  components: { TabList, ElementSelect, vueSeamlessScroll },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      chart: null,
      loading: true,
      chartOption: null,
      chartData: null,
      d1: [],
      d2: [],
      yd: [],
      pageIndex: 0,

      tabList: [
        {
          key: 0,
          label: '科创企业',
        },
        {
          key: 1,
          label: '百强企业',
        },
      ],
      tabIndex: 0,
      year: this.yearP,
    };
  },
  watch: {
    yearP() {
      this.getData();
    },
  },
  computed: {
    classOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    getData() {
      // this.chart = echarts.init(document.getElementById('chart4'));
      this.$api.market
        .getScztqkEntOutIn({
          year: this.yearP,
        })
        .then((res) => {
          let { data } = res.data;
          let arr = [],
            min = 0,
            max = 0;
          console.log(data, 889);
          data.move_in.map((x) => {
            if (min < x.num) min = x.num;
            let tmp = data.move_out.find((y) => y.city_name === x.city_name);
            arr.push({
              addr: x.city_name,
              in: x.num,
              out: tmp.num,
            });
          });
          data.move_in.map((x) => {
            if (max < x.num) max = x.num;
          });
          // for (const key in data) {
          //   if (Object.hasOwnProperty.call(data, key)) {
          //     const element = data[key];
          //     if (min < element['企业迁入总数']) min = element['企业迁入总数'];
          //     if (max < element['企业迁出总数']) max = element['企业迁出总数'];
          //     arr.push({
          //       addr: key.slice(0, 2),
          //       in: element['企业迁入总数'],
          //       out: element['企业迁出总数'],
          //     });
          //   }
          // }

          this.chartData = arr.map((x) => {
            return {
              ...x,
              inp: ((100 * x.in) / min).toFixed(2),
              outp: ((100 * x.out) / max).toFixed(2),
            };
          });
          console.log(this.chartData);
          this.loading = false;
        });
    },
    openTransferModal(addr, index) {
      this.$emit('openTransferModal', addr, index);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
// .chart-bar {
//   .chart-box();
//   display: flex;
//   flex-direction: column;
//   .title {
//     width: 100%;
//     div {
//       flex: 1;
//       justify-content: flex-end;
//       display: inline-flex;
//       line-height: 1;
//       align-items: center;
//       .element-select {
//         position: unset;
//       }
//     }
//     #btn-link {
//       margin-left: 32px;
//     }
//   }
.chart-con {
  // display: flex;
  // flex-direction: column;
  // flex: 1;
}
.tool-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px 10px 70px;
  > div {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #dcdcdc;
    line-height: 30px;
    i {
      display: inline-block;
      width: 13px;
      height: 9px;
      margin-right: 8px;
      background: rgba(0, 201, 255, 0.5);
      border: 1px solid #00c9ff;
    }
    &.tool-right {
      margin-left: 20px;
      i {
        background: rgba(0, 120, 255, 0.5);
        border: 1px solid #0078ff;
      }
    }
  }
}
#chart4 {
  height: 198px;
  flex: 1;
  overflow: hidden;
  // overflow-y: scroll;
  .line {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .addr {
      width: 24px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #c0c0c0;
      padding-left: 7px;
      // line-height: 36px;
      white-space: nowrap;
    }
    .chart-line {
      flex: 1;
      display: inline-flex;
      align-items: center;
      padding: 0 18px;
      .line-box {
        cursor: pointer;
        width: 48%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        span {
          font-family: Geometr706 BlkCn BT;
          font-weight: 900;
          font-size: 14px;
          color: #79c2ff;
          line-height: 24px;
          text-shadow: 0px 2px 2px rgba(16, 16, 16, 0.6);
        }
      }
      .line-left {
        // align-items: flex-end;
        .line-bg {
          position: relative;
          width: 100%;
          height: 6px;
          background: #072d4e;
          border-radius: 8px;
        }
        .line-bar {
          position: absolute;
          right: 0;
          width: 79px;
          height: 6px;
          background: linear-gradient(90deg, #49acff, #0074c6);
          border-radius: 8px;
        }
      }
      .line-right {
        align-items: flex-end;
        margin-left: 20px;
        span {
          color: #00d4c3;
        }
        .line-bg {
          position: relative;
          width: 100%;
          height: 6px;
          background: #072d4e;
          border-radius: 8px;
        }
        .line-bar {
          position: absolute;
          width: 101px;
          height: 6px;
          background: linear-gradient(270deg, #00d4c3, #00c67e);
          border-radius: 3px;
        }
      }
    }
  }
}
// }
</style>
